import { render, staticRenderFns } from "./edit-contact-dialog.vue?vue&type=template&id=4357c3b3&scoped=true&"
import script from "./edit-contact-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-contact-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-contact-dialog.vue?vue&type=style&index=0&id=4357c3b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4357c3b3",
  null
  
)

export default component.exports